import { useCallback } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import TransactionOverlay from '../../components/transactions/TransactionOverlay';
import ReceivePayments from '../ReceivePayments';
import type { CustomerPayment } from '../../types/customerPayment';
import { ReceivePaymentsHubProvider } from '../ReceivePaymentsHubContext';
import { useSalesTransactionsHub } from './SalesTransactionsHubContext';

const INVOICE_OVERLAY_PATTERN = /\/payment\/receive\/invoice\//;

const SalesPaymentReceiveOverlay = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { refetchList } = useSalesTransactionsHub();
  const listSearch = location.search.replace(/^\?/, '');
  const initState = location.state as { customerId?: number; invoiceId?: number } | null;
  const invoiceOverlayOpen = INVOICE_OVERLAY_PATTERN.test(location.pathname);

  const close = useCallback(() => {
    navigate({ pathname: '/sales-transactions', search: listSearch }, { preventScrollReset: true });
  }, [listSearch, navigate]);

  const handlePaymentSaved = useCallback(
    (_payment: CustomerPayment) => {
      refetchList();
      close();
    },
    [close, refetchList]
  );

  return (
    <ReceivePaymentsHubProvider>
      <TransactionOverlay headerless variant="wide" onClose={close}>
        <div
          className={`flex flex-1 min-h-0 flex-col${
            invoiceOverlayOpen ? ' pointer-events-none select-none opacity-60' : ''
          }`}
          aria-hidden={invoiceOverlayOpen}
        >
          <ReceivePayments
            embedded
            initialCustomerId={initState?.customerId}
            initialInvoiceId={initState?.invoiceId}
            onClose={close}
            onPaymentSaved={handlePaymentSaved}
          />
        </div>
      </TransactionOverlay>
      <Outlet />
    </ReceivePaymentsHubProvider>
  );
};

export default SalesPaymentReceiveOverlay;
